import React from "react";

/**
 * Sowjanya Studios — Branding Case Study Page
 * -------------------------------------------
 * Styles now live in their own file: SowjanyaCaseStudy.css
 * (previously an inline <style>{CSS}</style> block).
 * Every class name below was renamed to a unique, descriptive
 * name — no logic, structure, or styling values were changed.
 */
import "../index.css";
import "./BrandingCaseStudy.css";

import heroImg from "../assets/Branding/sowjanya/sowjanyaherosection.png";
import mockupImg from "../assets/Branding/sowjanya/sowjanyamockup.png";
import galleryMainImg from "../assets/Branding/sowjanya/Sowjanyagallerymain.png";
import logoMarkA from "../assets/Branding/sowjanya/sowjanyalogoA.png";
import logoMarkB from "../assets/Branding/sowjanya/sowjanyalogoB.png";
import billboardImg from "../assets/Branding/sowjanya/sowjanyabillboard.png";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

/* ------------------------------------------------------------------ */
/* Data                                                                 */
/* ------------------------------------------------------------------ */

const PALETTE = [
  { name: "Deep Gold", hex: "#B8860B" },
  { name: "Burgundy", hex: "#722F37" },
  { name: "Ivory Cream", hex: "#FFFFF0" },
  { name: "Charcoal", hex: "#2C2C2C" },
];

const IMPACT = [
  { n: "01", text: "Complete brand identity system delivered" },
  { n: "02", text: "Outdoor marketing campaign launched" },
  { n: "03", text: "Consistent brand presence across all touchpoints" },
];

/* ------------------------------------------------------------------ */
/* Section 1 — Hero + Project Overview                                 */
/* ------------------------------------------------------------------ */

function HeroSection() {
  return (
    <section className="case-study-section hero-section">
      <div className="hero-banner">
        <img src={heroImg} alt="Sowjanya Studios — draping tradition, defining style" />
        <div className="hero-banner-overlay">
          {/* <span className="hero-eyebrow">SOWJANYA STUDIOS</span>
          <h1>
            Draping Tradition.
            <br />
            Defining Style.
          </h1> */}
        </div>
      </div>

          <div style={{paddingTop:"20px",marginLeft:"6.2%"}}>
            <span className="section-eyebrow">Branding</span>
          <br/>
          <span className="section-eyebrow-secondary" sss>
            Visual Identity,
           
            Outdoor Marketing
          </span>
          <br/>
        </div>
      <div className="overview-grid" style={{paddingTop:"40px",marginLeft:"3%",paddingBottom:"150px"}}>
       
        <div className="overview-left">
          
           <span className="overview-eyebrow-project">
           Project Overview
          </span>

             <div className="overview-details">
          <dl>
            <div>
              <dt>Client</dt>
              <dd>Sowjanya Studios</dd>
            </div>
            <div>
              <dt>Services</dt>
              <dd>Brand Identity, Outdoor Marketing</dd>
            </div>
            <div>
              <dt>Year</dt>
              <dd>2024</dd>
            </div>
          </dl>
        </div>
        </div>

       

        <div className="overview-description">
          <p>
            Comprehensive brand identity development for Sowjanya Studios, a
            premium design studio specializing in traditional Indian fashion.
            We crafted a distinctive visual identity system including logo
            design, brand guidelines, and outdoor marketing materials that
            capture the essence of tradition meeting contemporary style.
          </p>
          {/* <a
            className="overview-link"
            href="https://sowjanyastudios.com"
            target="_blank"
            rel="noreferrer"
          >
            sowjanyastudios.com ↗
          </a> */}
        </div>
      </div>

      <div className="mockup-wrapper" style={{margin:"30px",borderRadius:"20px"}}>
        <div className="mockup-frame">
         
          <img src={mockupImg} alt="Sowjanya Studios logo on brand mockup screen" />
        </div>
      </div>
    </section>
  );
}

/* ------------------------------------------------------------------ */
/* Section 2 — Brand Identity                                          */
/* ------------------------------------------------------------------ */

function BrandIdentitySection() {
  return (
    <section className="case-study-section identity-section">
      <div className="identity-about">
        <span className="section-eyebrow" >About the Brand</span>
        <p>
          Sowjanya Studios is a premium design studio rooted in the rich
          traditions of Indian fashion and craftsmanship. The brand embodies
          the seamless fusion of heritage artistry with contemporary
          aesthetics, creating collections that honor tradition while
          embracing modern elegance. Every piece tells a story of cultural
          pride and refined taste.
        </p>
      </div>

      {/* <div className="identity-wrap">
        <h3 className="identity-heading">Brand Identity</h3>

         <div className="identity-grid">
         
          <div className="identity-card identity-card--palette">
            <div className="palette-swatch-row">
              {PALETTE.map((c) => (
                <span
                  key={c.hex}
                  className="palette-swatch"
                  style={{ background: c.hex }}
                  title={c.name}
                />
              ))}
            </div>

            <span className="section-block-label">Color Palette</span>

            <ul className="palette-swatch-list">
              {PALETTE.map((c) => (
                <li key={c.hex}>
                  <span className="palette-swatch-info">
                    <span className="palette-swatch-dot" style={{ background: c.hex }} />
                    <span className="palette-swatch-name">{c.name}</span>
                  </span>
                  <code className="palette-swatch-hex">{c.hex}</code>
                </li>
              ))}
            </ul>
          </div> 

         
           <div className="identity-card identity-card--typography">
            <span className="section-block-label section-block-label--dark">Typography</span>

            <div className="typography-sample">
              <h4 className="typography-display-font">Helvetica Neue</h4>
              <p>
                Clean, confident sans-serif carried across the whole site —
                used here at display weight for headings
              </p>
              <p className="typography-alphabet typography-display-font">
                A B C D E F G H I J K L M N O P Q R S T U V W X Y Z
                <br />
                a b c d e f g h i j k l m n o p q r s t u v w x y z
              </p>
            </div>

            <div className="typography-divider" />

            <div className="typography-sample typography-sample--last">
              <h4 className="typography-body-font">Helvetica</h4>
              <p>
                Same body face used sitewide, ensuring readability and
                visual continuity between case studies and marketing pages
              </p>
            </div>
          </div> 

        
           <div className="identity-card identity-card--logo">
            <span className="section-block-label">Logo Concept</span>
            <p>
              The Sowjanya Studios logo features the golden flame motif — a
              stylized form that merges the traditional Indian diya (lamp)
              silhouette with a modern typographic S. The flame symbolizes
              illumination, tradition, and creative transformation. Paired
              with regal gold tones, it communicates heritage craftsmanship
              elevated to contemporary luxury.
            </p>
          </div> 
        </div> 
      </div> */}

      {/* <div className="challenge-solution-grid">
        <div className="challenge-solution-card">
          <span className="section-block-label">The Challenge</span>
          <p>
            Create a brand identity that bridges traditional Indian
            craftsmanship with modern design sensibilities, appealing to
            both heritage-conscious and fashion-forward audiences.
          </p>
        </div>
        <div className="challenge-solution-card">
          <span className="section-block-label">The Solution</span>
          <p>
            We developed a sophisticated identity system anchored by the
            golden flame motif, symbolizing both tradition and
            transformation. The visual language extends across print,
            outdoor signage, and digital touchpoints with consistent warmth
            and elegance.
          </p>
        </div>
      </div> */}

      {/* <div className="impact-section">
        <span className="section-block-label">The Impact</span>
        <div className="impact-grid">
          {IMPACT.map((item) => (
            <div className="impact-item" key={item.n}>
              <span className="impact-number">{item.n}</span>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div> */}
    </section>
  );
}

/* ------------------------------------------------------------------ */
/* Section 3 — Project Gallery + Contact                                */
/* ------------------------------------------------------------------ */

function GallerySection() {
  return (
    <section className="case-study-section gallery-section">
      <h3 className="gallery-title">Project Gallery</h3>

      <div className="gallery-main-image">
        <img src={galleryMainImg} alt="Sowjanya Studios logo on burgundy silk" />
      </div>

      <div className="gallery-image-row">
        <img src={logoMarkA} alt="Sowjanya Studios logo mark, dark variant" />
        <img src={logoMarkB} alt="Sowjanya Studios logo mark, burgundy variant" />
      </div>

      <div className="gallery-billboard-image">
        <img src={billboardImg} alt="Sowjanya Studios outdoor billboard" />
      </div>

      <div className="gallery-text-block">
        <p>
          <strong>Sowjanya Studios</strong> is a saree brand that stands for
          quality, elegance, and tradition. Dedicated to offering
          high-quality sarees at wholesale prices, we ensure every piece
          reflects fine craftsmanship and timeless beauty.
        </p>
        <p>
          The swan in our logo represents grace and sophistication,
          symbolizing the unmatched quality of our sarees. It also connects
          to the “<strong>S</strong>” in Sowjanya, making the design both
          meaningful and memorable.
        </p>
        <p>
          At <strong>Sowjanya Studios,</strong> we believe sarees are not
          just attire but a symbol of heritage, dignity, and pride. By
          combining authenticity with affordability, we make it possible for
          every woman to experience the richness of genuine sarees without
          compromise.
        </p>
        <div className="gallery-text-divider" aria-hidden="true">
          ◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆
        </div>
      </div>

      {/* <ContactSection /> */}
    </section>
  );
}

/* ------------------------------------------------------------------ */
/* Root component                                                       */
/* ------------------------------------------------------------------ */

export default function SowjanyaCaseStudy() {
  return (
    <div className="case-study-page">
      <HeroSection />
      <BrandIdentitySection />
      <GallerySection />
    </div>
  );
}